import { render, staticRenderFns } from "./CompareMenu.vue?vue&type=template&id=5169f58c&"
import script from "./CompareMenu.vue?vue&type=script&lang=js&"
export * from "./CompareMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5169f58c')) {
      api.createRecord('5169f58c', component.options)
    } else {
      api.reload('5169f58c', component.options)
    }
    module.hot.accept("./CompareMenu.vue?vue&type=template&id=5169f58c&", function () {
      api.rerender('5169f58c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/headers/shared/CompareMenu.vue"
export default component.exports